/**
 * Classification of aborted Realtime Database transactions, shared by UserService (create of the
 * own record) and AccessGrantService (create of a poll / answer key) - both retry a transient abort
 * once (workorder-ensure-key-disconnect-retry-2026-10-30, task 1).
 *
 * Deliberately framework-free (no Angular import), like `db-errors.ts`.
 */

/** how long the retry of an aborted transaction waits for the connection after a 'disconnect' */
export const RETRY_WAIT_FOR_CONNECTION_MS = 3000;
/** pause before the retry of a transaction that ran into 'maxretry' */
export const RETRY_PAUSE_AFTER_MAXRETRY_MS = 500;

/**
 * Transaction abort reasons documented by Firebase - none of them indicates a bug.
 * The web SDK reports an overriding set() as 'set', the native SDKs as 'overriddenBySet'.
 */
export const TRANSIENT_TRANSACTION_ABORTS = ['disconnect', 'maxretry', 'overriddenbyset', 'set'];

/** the abort reason (lower case) when `error` is one of TRANSIENT_TRANSACTION_ABORTS, otherwise null */
export function transientTransactionAbort(error: unknown): string | null {
    const message = (error as Error)?.message?.toLowerCase();
    // bare reason (web SDK: `new Error(abortReason)`) or reason with a detail suffix
    return (!!message && TRANSIENT_TRANSACTION_ABORTS.find(reason =>
        message === reason || message.startsWith(reason + ' ') || message.startsWith(reason + ':'))) || null;
}

/** `String(error)` for Error instances ("Error: disconnect"), the JSON for plain objects (`{code, message}` from the SDK) */
export function describeError(error: unknown): string {
    const text = String(error);
    return text === '[object Object]' ? JSON.stringify(error) : text;
}
